///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnInit } from '@angular/core';
import { UserDTO } from '../../generated/shared-types.model';
import { Principal } from '../../shared/auth/principal.service';
import { GtthCtxSensitiveHelpService } from '../../shared/context-sensitive-help/ctx-sensitive-help.service';
import { GtthUserSessionRestoringService } from '../../shared/auth/user-session-restoring/user-session-restoring.service';
import { Lang, SuiTranslateService } from '@siklu/sui-lib/localization';

import localeEN from '../../../localization/en.json';
import { Store } from '@ngrx/store';
import { getSystemInfo } from '../../shared/store/systemInfo/system-info.actions';
import { PreloaderService } from '../../services/preloader.service';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { SuiNotificationService } from '@siklu/sui-lib/infrastructure';
import { logoutAction } from '../../shared/store/meta-actions';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'winde-main',
    templateUrl: './main.component.html',
    styleUrls: ['main.component.scss'],
    standalone: false
})
export class WindeMainComponent implements OnInit {
    constructor(
        public readonly preloaderService: PreloaderService,
        private readonly principal: Principal,
        private readonly router: Router,
        private readonly ctxSensitiveHelpService: GtthCtxSensitiveHelpService,
        private readonly userSessionRestoreService: GtthUserSessionRestoringService,
        private readonly translateService: SuiTranslateService,
        private readonly store: Store,
        private readonly suiNotificationsService: SuiNotificationService,
        private readonly dialogService: MatDialog
    ) {
        this.translateService.registerSupportedLocalization(Lang.EN, localeEN);
        this.translateService.use(Lang.EN);
    }

    ngOnInit() {
        this.store.dispatch(getSystemInfo());
        this.router.events.subscribe((event) => {
            if (event instanceof RouteConfigLoadStart) {
                this.preloaderService.show();
            } else if (event instanceof RouteConfigLoadEnd) {
                this.preloaderService.hide();
            }
        });

        this.principal.getAuthenticationState().subscribe((account: UserDTO) => {
            if (account) {
                this.ctxSensitiveHelpService.loadConfig();
                if (!account.emailVerificationRequired && !account.eulaAcceptanceRequired) {
                    this.userSessionRestoreService.tryRestore();
                }
            } else {
                this.dialogService.closeAll();
                this.suiNotificationsService.closeAll();
                this.store.dispatch(logoutAction());
            }
        });
    }
}
